import * as K from 'common/constants';
import { IS_DEVELOPMENT } from 'common/constants';
import { buildAbsoluteUrl } from './location';

function isValidOriginalUrl(originalUrl: string): boolean {
  try {
    const parsedUrl = new URL(originalUrl);
    return parsedUrl && parsedUrl.protocol.startsWith('https') && parsedUrl.hostname.endsWith('scalyr.com');
  } catch (e) {
    return false;
  }
}

function constructOriginalUrl(originalUrl: string): URL {
  const original = new URL(originalUrl);
  const originalUrlParams = new URLSearchParams(original.search);
  const paramEntries = [...originalUrlParams.entries()];
  if (!paramEntries.length) {
    return new URL(originalUrl);
  }
  const newOriginalUrlParams = new URLSearchParams();
  for (const [key, value] of originalUrlParams) {
    newOriginalUrlParams.append(key, value);
  }
  const constructedOriginalUrl = new URL(original.href);
  constructedOriginalUrl.search = newOriginalUrlParams.toString();
  return constructedOriginalUrl;
}

// This will be the url that user will be redirected to after logging in
export function getRedirectUrl(urlParam?: string) {
  const searchUrl = urlParam ? urlParam : window.location.search;
  const searchParams = new URLSearchParams(searchUrl);
  let originalUrl = searchParams.get(K.URL_PARAM.AUTH_ORIGINAL_URL) || buildAbsoluteUrl(K.ROUTE.ROOT);
  if (!IS_DEVELOPMENT && !isValidOriginalUrl(originalUrl)) {
    // validating that the redirect url is a valid scalyr url
    originalUrl = buildAbsoluteUrl(K.ROUTE.ROOT);
  }
  originalUrl = originalUrl.replace('+', '%2B');
  const redirectUrl = constructOriginalUrl(originalUrl); //construct the original url with parameters
  const paramEntries = [...searchParams.entries()];
  if (!paramEntries.length || paramEntries.length === 1) {
    // if there are no parameters at all or the url is structured to be ?originalUrl=https://app.scalyr.com/ and no other search params are present
    return redirectUrl.toString();
  }
  const newSearchParams = new URLSearchParams();
  if (redirectUrl.search) {
    // Checking if there were any parameters already present with the originalUrl param
    for (const [key, value] of redirectUrl.searchParams) {
      newSearchParams.append(key, value);
    }
  }
  for (const [key, value] of searchParams) {
    if (key !== K.URL_PARAM.AUTH_ORIGINAL_URL) {
      newSearchParams.append(key, value);
    }
  }
  redirectUrl.search = newSearchParams.toString();
  return redirectUrl.toString();
}
